import { Box, Stack } from '@mantine/core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { adjustToBrowserTimezone, isSameDay, useChartDatas } from '@mygpt/app';
import CustomContainer from '@/components/CustomContainer';
import CustomContainerHeader from '@/components/CustomContainer/CustomContainerHeader';
import Heatmap, { HeatmapDataItem } from '@/components/Dashboard/Chart/components/Heatmap';

const TotalConversationsHeatmap = () => {
  const { t } = useTranslation();
  const { datas, times } = useChartDatas();

  const data: HeatmapDataItem[] = useMemo(() => {
    const arr: HeatmapDataItem[] = [];
    times.map((time) => {
      const objTimes: { time: string; count: number }[] = [];
      datas.map((data) => {
        if (data.created_session_count && isSameDay(time, data.updated_at)) {
          objTimes.push({
            time: adjustToBrowserTimezone(data.updated_at),
            count: data.created_session_count,
          });
        }
      });

      const obj: HeatmapDataItem = {
        date: time,
        times: objTimes,
      };

      arr.push(obj);
    });
    return arr;
  }, [datas, times]);

  return (
    <>
      <CustomContainerHeader
        title={t('dashboard.card.total_conversations_heatmap')}
        label={t('dashboard.card.total_conversations_heatmap_tip')}
      />
      <CustomContainer>
        <Stack gap={50}>
          <Box w={'100%'} className="border border-gray-200 rounded-xl p-4">
            <Heatmap data={data} />
          </Box>
        </Stack>
      </CustomContainer>
    </>
  );
};

export default TotalConversationsHeatmap;
